import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContracts,
  fetchPolicyHolderInfo,
  loadingUser,
} from "../../action";
import "../../../src/styles/theme.scss";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography, Input } from "@mui/material";
import ContractDeclaration from "./ContractDeclaration";
import ContractDeclarationTable from "./ContractDeclarationTable";
import DeclarationFrom from "./ContractDetailsFrom";
import ContractTable from "./ContractDetailsTable";
import { styled } from "@mui/material/styles";
import { getPolicyholderId } from "../../utils/helper";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
const StyledLabel = styled(Typography)({
  fontSize: "2vw",
  fontWeight: "bold",
  color: "#000",
  marginLeft: "2rem",
});

function ContractTab() {
  const SignInSuccess = useSelector((state) => state);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [insureeCheck, setInsureeCheck] = useState(false);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [policyHolderId, setPolicyHolderId] = useState();
  const [insureeData, setInsureeData] = useState();
  const [filter, setFilter] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSnakBar, setShowSnakBar] = useState(false);
  const PolicyholderIdStore = localStorage.getItem("policyholderId");
  const params = [
    "isDeleted: false",
    "first: 10",
    'orderBy: ["code"]',
    `policyHolder_Id:"${PolicyholderIdStore}"`,
  ];

  let mutation = SignInSuccess?.profileReducer?.mutations;
  useEffect(() => {
    if (snackbarMessage) {
      if (mutation && mutation.length > 0 && mutation[0]?.status === 2) {
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setShowDialog(false);
      } else if (mutation && mutation.length > 0 && mutation[0]?.status === 1) {
        setSnackbarSeverity("error");
        setSnackbarMessage(t("Failed to done any action in Contract."));
        setSnackbarOpen(true);
        setShowDialog(false);
      } else if (!mutation) {
        setSnackbarOpen(false);
      }
    }
  }, [mutation]);
  const handleSnackbarClose = async (event, reason) => {
    // window.location.reload();
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    dispatch(loadingUser(token));
    if (!!PolicyholderIdStore) {
      dispatch(fetchContracts(params));
    }
  }, [mutation, getPolicyholderId]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.currentUserResponseData) {
      setCurrentUSer(SignInSuccess?.profileReducer?.currentUserResponseData);
    }
  }, [SignInSuccess]);
  useEffect(() => {
    if (currentUser?.id) {
      dispatch(fetchPolicyHolderInfo(currentUser?.id));
    }
  }, [currentUser]);
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
      setPolicyHolderId(
        SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
          .policyHolder
      );
    }
  }, [policyHolderId, SignInSuccess]);
  return (
    <Grid container>
      <Grid container display="flex" justifyContent="space-between">
        <StyledLabel>{t("Employee Declaration")}</StyledLabel>
      </Grid>

      <ContractDeclaration
        policyHolderId={!!policyHolderId && policyHolderId}
        setFilter={setFilter}
        filter={filter}
        setSnackbarMessage={setSnackbarMessage}
        snackbarMessage={snackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
        snackbarOpen={snackbarOpen}
        setShowSnakBar={setShowSnakBar}
      />

      <ContractDeclarationTable
        policyHolderId={policyHolderId}
        filter={filter}
        setInsureeData={setInsureeData}
        setSnackbarMessage={setSnackbarMessage}
        snackbarMessage={snackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
        snackbarOpen={snackbarOpen}
      />
      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Grid>
  );
}

export default ContractTab;
